<template>
  <feedback />
</template>

<script>
import Feedback from '@/components/Feedback/Feedback'

export default {
  name: 'FeedbackView',
  components: {
    Feedback,
  }
}
</script>
